import { TAvailableActions } from '../../types/availableActions';
import { TMessage, TOutcomingStatus } from '../../types/messages';

type TReplyableMessage = TMessage & { status?: TOutcomingStatus };

export const isSendMessageAvailable = (availableActions?: TAvailableActions[] | null): boolean => {
  return Boolean(availableActions?.includes('sendMessage'));
};

export const isReplyableMessage = (message?: TReplyableMessage): boolean => {
  if (!message) {
    return false;
  }

  const { type: messageType = 'text', isDeleted: isMessageDeleted, status } = message;

  const isAvailableByMessageType = !['systemInfo', 'textAndImages'].includes(messageType);
  /** У входящих статус затирается в parseMessage  */
  const isAvailableByMessageStatus = !status || !['pending', 'failed'].includes(status);

  return Boolean(isAvailableByMessageType && !isMessageDeleted && isAvailableByMessageStatus);
};
